import type { Translate } from '@client-app/i18n';

export interface MemberInviteUpgradePrompt {
    title: string;
    heading: string;
    description: string;
    primaryActionLabel: string;
    secondaryActionLabel: string;
}

export type MemberInviteLimitActionTarget = 'plans' | 'sales' | 'none';

export const getMemberInviteUpgradePrompt = (t: Translate): MemberInviteUpgradePrompt => {
    return {
        title: t('website.membersSettings.upgradeToInviteMembersTitle'),
        heading: '',
        description: t('website.membersSettings.soloInviteLimitDescription'),
        primaryActionLabel: t('website.pricing.viewPlans'),
        secondaryActionLabel: t('website.integrationsSettings.notNow'),
    };
};

export const getMemberRolesUpgradePrompt = (t: Translate): MemberInviteUpgradePrompt => {
    return {
        title: t('website.membersSettings.upgradeRequiredTitle'),
        heading: '',
        description: t('website.membersSettings.rolesUpgradeDescription'),
        primaryActionLabel: t('website.membersSettings.viewTeamPlan'),
        secondaryActionLabel: t('website.integrationsSettings.notNow'),
    };
};

export interface MemberInviteLimitPrompt {
    title: string;
    description: string;
    primaryActionLabel: string;
    secondaryActionLabel: string;
    primaryActionTarget: MemberInviteLimitActionTarget;
}

export const getMemberInviteLimitPrompt = (
    t: Translate,
    options: {
        planName?: string | null;
        memberLimit?: number | null;
        primaryActionTarget: MemberInviteLimitActionTarget;
    },
): MemberInviteLimitPrompt => {
    const {
        planName,
        memberLimit,
        primaryActionTarget,
    } = options;
    const hasPlanLimit = Boolean(planName && memberLimit);
    const description = primaryActionTarget === 'none'
        ? t('website.membersSettings.pluginWorkspaceUserLimitDescription', {
            limit: memberLimit,
        })
        : primaryActionTarget === 'sales'
        ? hasPlanLimit
            ? t('website.membersSettings.workspaceUserLimitSalesDescription', {
                plan: planName,
                limit: memberLimit,
            })
            : t('website.membersSettings.workspaceUserLimitSalesFallbackDescription')
        : hasPlanLimit
            ? t('website.membersSettings.workspaceUserLimitPlansDescription', {
                plan: planName,
                limit: memberLimit,
            })
            : t('website.membersSettings.workspaceUserLimitPlansFallbackDescription');

    return {
        title: t('website.membersSettings.workspaceUserLimitReachedTitle'),
        description,
        primaryActionLabel: primaryActionTarget === 'none'
            ? t('common.gotIt')
            : primaryActionTarget === 'sales'
            ? t('website.pricing.contactSales')
            : t('website.pricing.viewPlans'),
        secondaryActionLabel: t('website.integrationsSettings.notNow'),
        primaryActionTarget,
    };
};
